import React, { useState } from 'react';
import pluralize from 'pluralize';
import DropdownWrapper from '@components/common/dropdown_wrapper/main';
import './styles/_create_new_dropdown.scss';
import PortalForm from '../../portals/portal/portal_form';
import NewBrandfolderModal from './NewBrandfolderModal';

interface CreateNewDropdownProps {
  atBrandfolderLimit: boolean;
  atPortalLimit: boolean;
  libraryName: string;
  organizationKey: string;
  name: string;
  slug: string;
}

const CreateNewDropdown = ({
  atBrandfolderLimit,
  atPortalLimit,
  libraryName,
  name,
  organizationKey,
  slug
}: CreateNewDropdownProps): JSX.Element => {
  const [showForm, setShowForm] = useState(false);
  const [closeDropdown, setCloseDropdown] = useState(false);
  const [showNewBrandfolderModal, setShowNewBrandfolderModal] = useState(false);
  const toggleForm = (): void => setShowForm((prevState) => !prevState);
  const toggleDropdown = (): void => setCloseDropdown((prevState) => !prevState);

  const redirectToQuote = (): void => { window.location.href = "https://brandfolder.com/quote"; };

  const renderBrandfolderDropdown = (): JSX.Element => {
    if (atBrandfolderLimit) {
      return (
        <li
          key="brandfolder"
          className="create-new-dropdown__list--item upgrade-brandfolder"
          onClick={redirectToQuote}
          role="button"
          tabIndex={0}
        >
          <span className="bff-grid-view icon" />
          {bfTranslate("Upgrade for")} {bfTranslate(pluralize(libraryName))}
        </li>
      );
    }

    return (
      <li
        key="brandfolder"
        className="create-new-dropdown__list--item"
        onClick={(): void => setShowNewBrandfolderModal(true)}
        role="button"
        tabIndex={0}
      >
        <span className="bff-grid-view icon" />
        {bfTranslate(libraryName)}
      </li>
    );
  };

  const renderPortalDropdown = (): JSX.Element | null => {
    // For Beta Mode
    if (atPortalLimit) { return null; }

    // if (atPortalLimit) {
    //   return (
    //     <li
    //       className="create-new-dropdown__list--item upgrade-portal"
    //       key="portal"
    //       onClick={redirectToQuote}
    //       role="button"
    //       tabIndex={0}
    //     >
    //       <span className="bff-portal icon" />
    //       {`${bfTranslate("Upgrade for")} ${bfTranslate("Brand Portal")}s`}
    //     </li>
    //   );
    // }

    return (
      <li
        key="portal"
        className="create-new-dropdown__list--item create-portal"
        onClick={toggleForm}
        role="button"
        tabIndex={0}
      >
        <span className="bff-portal icon" />
        {bfTranslate("Brand Portal")}
      </li>
    );
  };

  const dropdownContents: JSX.Element = (
    <ul className="create-new-dropdown__list">
      {renderBrandfolderDropdown()}
      {renderPortalDropdown()}
    </ul>
  );

  return (
    <>
      <DropdownWrapper
        close={closeDropdown}
        closeCallback={toggleDropdown}
        cssTransitionClasses="fade-in-translate"
        dropdownContents={dropdownContents}
        openOnClick={false}
        wrapperClassnames="create-new-dropdown"
      >
        <span className="bff-caret-down" />
      </DropdownWrapper>
      {showForm
        && (
          <PortalForm
            closeModal={toggleForm}
            organizationKey={organizationKey}
          />
        )
      }
      {showNewBrandfolderModal && (
        <NewBrandfolderModal
          closeModal={(): void => setShowNewBrandfolderModal(false)}
          libraryName={libraryName}
          name={name}
          slug={slug}
        />
      )}
    </>
  );
};

export default CreateNewDropdown;
